<mat-form-field
  class="relative input-wrapper-default w-100"
  appearance="outline"
  floatLabel="always"
  [class.mb-1]="formControl.invalid && formControl.touched"
  [ngClass]="fieldClass || {}"
  [formGroup]="chipsGroup"
>
  <mat-label *ngIf="label">
    <span>{{ label }}</span>
    <span class="color-error" *ngIf="isRequired">*</span>
    :
  </mat-label>
  <mat-chip-grid #chipList [attr.aria-label]="label" multiple *ngIf="formControl">
    <mat-chip-row
      *ngFor="let element of formControl.controls; let valueIndex = index"
      [class.mat-chip-selected]="element.value"
      [value]="element.value"
      (removed)="removeElement(element)"
      class="chip"
      [attr.data-test-id]="[testId, 'item', valueIndex] | join"
      [class.chip-invalid]="element.invalid"
    >
      <span class="truncate" [title]="element.value">{{ element.value }}</span>
      <mat-icon matChipRemove [attr.data-test-id]="[testId, 'item', valueIndex, 'remove'] | join" [class.disabled]="isDisabled">
        cancel
      </mat-icon>
    </mat-chip-row>
    <input
      [matChipInputFor]="chipList"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="addElement($event)"
      [attr.data-test-id]="[testId, 'item'] | join"
      #newChipInput
      (keydown.backspace)="onBackspace($event, newChipInput)"
      (paste)="onPaste($event)"
      (change)="onTouchFn(true)"
      [disabled]="isDisabled"
      [type]="type"
    />
  </mat-chip-grid>
  <mat-error *ngIf="formControl.errors" [attr.data-test-id]="[testId, 'item', 'error'] | join">
    <span class="icon icon-error fs-md"></span>
    {{ messageService.getControlErrorMessage(formControl.errors) }}
  </mat-error>
</mat-form-field>
